"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const Decode = __importStar(require("./decode"));
exports.Decode = Decode;
const Encode = __importStar(require("./encode"));
exports.Encode = Encode;
const Allocate = __importStar(require("./allocate"));
exports.Allocate = Allocate;
//# sourceMappingURL=index.js.map